import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';

function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img className="avatar" src="https://github.com/caaeduardo.png" alt="Avatar" style={{width: '175px', height: '175px', borderRadius: '50%'}} />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/caaeduardo" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/carlos-eduardo-867a881b7/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
          <h1>Carlos Eduardo</h1>
          <p>Development Analyst</p>

          <div className="mobile_social_icons">
            <a href="https://github.com/caaeduardo" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/carlos-eduardo-867a881b7/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;